import React, { useEffect, useRef, useState } from 'react';
import './Testimonials.css';

const Testimonials = () => {
  const [activeSection, setActiveSection] = useState(0);
  const [typingStates, setTypingStates] = useState({});
  const [videoTypingText, setVideoTypingText] = useState('');
  const [isVideoTyping, setIsVideoTyping] = useState(false);
  const sectionRefs = useRef([]);
  const resizeTimeoutRef = useRef(null);

  const testimonials = [
    {
      id: 1,
      name: "Jeong-ho",
      title: "Data Scientist",
      avatar: "https://static.wixstatic.com/media/fc7570_201efc2bf6e941d58702e0fb4bd86619~mv2.jpg/v1/fill/w_54,h_55,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Image-empty-state.jpg",
      text: "I wanted to share my very positive experiences with Mobius Engine. I started a job search as a Senior Data Scientist in August, and I was dreading the application process. I always found it causes a lot of friction in the job process, and the prospect of frustration of going through job boards and filling out endless applications to hear no response almost made me to not even want to start. When I heard about Mobius Engine I was thrilled - I was subscribed to the basic plan, and I was paying $1 per application being sourced and sent, which I viewed as a incredible deal. The team was very responsive to my requests on filtering on type of industry, and their approach led me to consider some interesting lines of work that I wasn't even looking for. I was able to land around a dozen first round interviews through the services, which converted into two offers. Through the service, I was able to find my dream position! Mobius Engine takes away the frustrating and time consuming part of the job search process so I could focus on interviewing and my day to day life, and I'm extremely appreciative. I recommend it to my friends who are going through tech job searches, and I would heavily encourage anyone to give it a try!"
    },
    {
      id: 2,
      name: "Linda",
      title: "Security Specialist",
      avatar: "https://static.wixstatic.com/media/fc7570_2cd03fe049974caca40586b26f64858d~mv2.jpg/v1/fill/w_54,h_55,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Image-empty-state.jpg",
      text: "I've been part of layoffs twice this year and I have to say it's been rough. I kept receiving the same of advice, \"just keep applying everyday, it's your job now\". All of that sounds a lot easier said than done because the depression at times has been absolutely crippling, interfering with my motivation for job search efforts. I was struggling for months after my first layoff in March and then I stumbled upon MobiusEngine.ai. Although I'm still on the market, this service has been an absolute game changer. I was laid off as a Senior Technical Program Manager and I am aiming to up level my career into Director+ roles. Mobius Engine has been able to garner countless interviews by applying to hundreds of jobs for me per month. I have to admit that due to my depression that at many times has left me feeling stuck in quicksand, I would not have been able to accomplish all of that by myself. I have seen other application engine services out there but what sets Mobius Engine apart for me is the personalized approach which helped address my unique needs. They also offer an amazing ai based resume optimization tool. This has definitely helped reduce my anxiety about the job search process and I'm just passing this along for others that are struggling right now. I hope this helps you!"
    },
    {
      id: 3,
      name: "Praneet",
      title: "Program Manager",
      avatar: "https://static.wixstatic.com/media/fc7570_04c4a4e342e447af8183d85f470042aa~mv2.jpg/v1/fill/w_54,h_55,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Image-empty-state.jpg",
      text: "I can't thank MobiusEngine.ai enough for changing the game in my job search. As a Level 6 Technical Program Manager, I was looking for a shift in my career, and Mobius Engine delivered. Their one-on-one coaching sessions with Ashwin were incredibly impactful, guiding me in creating an effective application strategy and resume. What sets Mobius Engine apart is their personalised approach, where I could brainstorm and receive coaching tailored to my unique needs. With their help, I landed a Senior Manager role at GEICO, overseeing a team of Product Managers. Mobius Engine not only delivered results but also reduced my anxiety about the job search process. While I used their platform occasionally, it was the human touch that made all the difference. If you're looking for a service that truly cares about your career transition and success, MobiusEngine.ai is the way to go. I'm so satisfied with my experience that I'll definitely be reaching out to them again in the future for any job-seeking needs."
    }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = sectionRefs.current.indexOf(entry.target);
            if (index !== -1) {
              setActiveSection(index);
              
              // Add animate class with a small delay to prevent flickering
              setTimeout(() => {
                entry.target.classList.add('animate');
              }, 100);
              
              // Start typing animation for video section
              if (index === 0 && !isVideoTyping) {
                setIsVideoTyping(true);
                const videoText = "*Photos and names changed for client privacy. More references available on request.";
                let i = 0;
                const typeVideoText = () => {
                  if (i < videoText.length) {
                    setVideoTypingText(videoText.slice(0, i + 1));
                    i++;
                    setTimeout(typeVideoText, 40);
                  }
                };
                setTimeout(typeVideoText, 1000);
              }
              
              // Start typing animation for testimonial sections
              if (index > 0 && !typingStates[index]) {
                setTypingStates(prev => ({ ...prev, [index]: { text: '', isTyping: true } }));
                
                const text = testimonials[index - 1].text;
                let i = 0;
                const typeText = () => {
                  if (i < text.length) {
                    setTypingStates(prev => ({
                      ...prev,
                      [index]: { ...prev[index], text: text.slice(0, i + 1) }
                    }));
                    i++;
                    setTimeout(typeText, 25);
                  } else {
                    setTypingStates(prev => ({
                      ...prev,
                      [index]: { ...prev[index], isTyping: false }
                    }));
                  }
                };
                
                setTimeout(typeText, 1500);
              }
            }
          }
        });
      },
      { threshold: 0.5, rootMargin: '-10% 0px -10% 0px' }
    );

    sectionRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => {
      sectionRefs.current.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, [testimonials, typingStates, isVideoTyping]);

  // Handle resize flickering
  useEffect(() => {
    const handleResize = () => {
      // Clear previous timeout
      if (resizeTimeoutRef.current) {
        clearTimeout(resizeTimeoutRef.current);
      }
      
      // Temporarily disable transitions during resize
      document.body.classList.add('resize-animation-stopper');
      
      // Re-enable transitions after resize is complete
      resizeTimeoutRef.current = setTimeout(() => {
        document.body.classList.remove('resize-animation-stopper');
      }, 400);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      if (resizeTimeoutRef.current) {
        clearTimeout(resizeTimeoutRef.current);
      }
    };
  }, []);

  return (
    <div className="testimonials-page">
      {/* Video Section */}
      <div 
        className="video-section"
        ref={(el) => (sectionRefs.current[0] = el)}
      >
        <div className="video-content">
          <h1 className="testimonials-title">What Our Clients Say</h1>
          <h2 className="testimonials-subtitle">About Us</h2>
          
          <div className="small-video-container">
            <iframe
              className="testimonial-video"
              src="https://www.youtube.com/embed/2q30UklnQl0"
              title="Client Testimonial Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          
          <div className="video-typing-container">
            <p className="video-typing-text">{videoTypingText}</p>
          </div>
          <p className="testimonials-note">* More testimonials available upon request</p>
        </div>
      </div>

      {/* Testimonial Sections */}
      {testimonials.map((testimonial, index) => (
        <div
          key={testimonial.id}
          className="testimonial-section"
          ref={(el) => (sectionRefs.current[index + 1] = el)}
        >
          <div className="testimonial-layout">
            <div className="client-profile-container">
              <div className="client-profile">
                <div className="client-avatar">
                  <img src={testimonial.avatar} alt={testimonial.name} />
                </div>
                <div className="client-info">
                  <h3 className="client-name">{testimonial.name}</h3>
                  <p className="client-title">{testimonial.title}</p>
                </div>
              </div>
            </div>
            
            <div className="testimonial-text-container">
              <div className="testimonial-text">
                <p className="typing-testimonial">
                  {typingStates[index + 1]?.text || ''}
                </p>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Testimonials;
